import { ApiService } from './api.service';
import { endpoints } from './endpoints';
import type {
  ILlmConfig,
  CreateLlmConfigPayload,
  UpdateLlmConfigPayload,
  TestConnectionResult,
  ListLlmModelsPayload,
  ListLlmModelsResult,
} from '@/types/entities/llm-config';

/**
 * Service for managing LLM provider configurations
 */
class LlmConfigApiService extends ApiService {
  async getAll(): Promise<ILlmConfig[]> {
    return this.get<ILlmConfig[]>(endpoints.llmConfig.all);
  }

  async getByOrganization(organizationId: string): Promise<ILlmConfig[]> {
    return this.get<ILlmConfig[]>(endpoints.llmConfig.byOrganization(organizationId));
  }

  async getById(id: string): Promise<ILlmConfig> {
    return this.get<ILlmConfig>(endpoints.llmConfig.byId(id));
  }

  async create(payload: CreateLlmConfigPayload): Promise<{ id: string }> {
    return this.post<{ id: string }>(endpoints.llmConfig.create, payload);
  }

  async update(id: string, payload: UpdateLlmConfigPayload): Promise<{ id: string }> {
    return this.patch<{ id: string }>(endpoints.llmConfig.update(id), payload);
  }

  async remove(id: string): Promise<{ id: string }> {
    return this.delete<{ id: string }>(endpoints.llmConfig.remove(id));
  }

  async testConnection(id: string): Promise<TestConnectionResult> {
    return this.post<TestConnectionResult>(endpoints.llmConfig.test(id));
  }

  async listModels(payload: ListLlmModelsPayload): Promise<ListLlmModelsResult> {
    return this.post<ListLlmModelsResult>(endpoints.llmConfig.models, payload);
  }

  async listModelsByConfigId(id: string): Promise<ListLlmModelsResult> {
    return this.get<ListLlmModelsResult>(endpoints.llmConfig.modelsByConfig(id));
  }
}

export const llmConfigApiService = new LlmConfigApiService();
